"use client";

import imageHpHero from "@/assets/images/screens/homepage/hero.jpg";
import imageHpHeroDesktop from "@/assets/images/screens/homepage/hero-desktop@2x.jpg";
import Image from "next/image";
import Button from "@/components/ui/Button";
import { useLeadModal } from "@/contexts/leadModal";
import { useMediaQuery } from "@/hooks/ui/useMediaQuery";
import HeroVideo from "@/components/sections/HeroVideo";

export default function Hero() {
  const leadModal = useLeadModal();

  return (
    <div>
      <div className="fixed inset-x-5 bottom-5 z-20 lg:hidden">
        <Button onClick={() => leadModal.setFlow({ flow: "default" })}>
          Zapytaj o ofertę
        </Button>
      </div>
      <div className="relative overflow-hidden">
        <Image
          src={imageHpHero}
          alt={""}
          className="absolute inset-0 h-full w-full object-cover lg:hidden"
        />
        <Image
          src={imageHpHeroDesktop}
          alt={""}
          className="absolute inset-0 hidden h-full w-full object-cover lg:block"
        />
        {0 && <HeroVideo />}
        <div className="relative z-10 m-auto flex min-h-lvh max-w-screen-xl items-end px-5 pb-20 text-white lg:justify-end lg:px-5 lg:pb-28 lg:pt-80">
          <div>
            <div className={"drop-shadow-lg"}>
              <div className={"text-3xl font-bold lg:text-[40px]/[56px]"}>
                Zainwestuj
                <br className={"lg:hidden"} /> w apartament
                <br />
                <span className={"font-medium"}>w 5* hotelu&nbsp;</span>
                <br className={"lg:hidden"} />i zarabiaj nawet
              </div>
              <div className="-mb-1 -ml-2 -mt-2 flex items-start text-[180px]/[180px] font-black tracking-[-8px] lg:-mb-3 lg:-ml-3 lg:-mt-8 lg:text-[320px]/[320px] lg:tracking-[-25px]">
                <div>
                  <span>12</span>
                  <span
                    className={
                      "-ml-1.5 text-[155px]/[155px] lg:-ml-2 lg:text-[275px]/[275px]"
                    }
                  >
                    ,
                  </span>
                  <span className={"-ml-6 lg:-ml-10"}>1</span>
                </div>
                <span
                  className={
                    "ml-2 mt-4 inline-block text-[80px]/[80px] lg:ml-1 lg:mt-6 lg:text-[180px]/[180px]"
                  }
                >
                  %
                </span>
              </div>
              <div className={"text-xl font-medium lg:text-[40px]/[56px]"}>
                w skali roku
              </div>
            </div>
            <Button
              className="hidden lg:mt-4 lg:block lg:w-72"
              onClick={() => leadModal.setFlow({ flow: "default" })}
            >
              Zapytaj o ofertę
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
